









import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Loading component.
 */
@Component
export default class Loading extends Vue {
	/// Properties
	@Prop({ default: 48 }) size!: number;
}
